import React from "react";
import PropTypes from "prop-types";

import styles from "./Card.module.css";

export function Card({ header, onClick, btnTitle, children, readOnly }) {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <span>{header}</span>
        {btnTitle && !readOnly && (
          <button
            className={styles.headerButton}
            type="button"
            onClick={onClick}
          >
            {btnTitle}
          </button>
        )}
      </div>
      <div className={styles.cardBody}>{children}</div>
    </div>
  );
}

Card.propTypes = {
  //Displays the header
  header: PropTypes.string,
  //Optional function passed in if there is a btn in the header
  onClick: PropTypes.func,
  //Optional title to display btn in header
  btnTitle: PropTypes.string,
};
